export enum FlightClassTypes {
  ECONOMY = 'ECONOMY',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST',
  PREMIUMECONOMY = 'PREMIUMECONOMY'
}

export enum FlightClassNumericTypes {
  BUSINESS = '0',
  FIRST = '1',
  ECONOMY = '2',
  PREMIUMECONOMY = '3'
}

export enum FlightClassOrder {
  BUSINESS = '2',
  FIRST = '1',
  ECONOMY = '4',
  PREMIUMECONOMY = '3',
}

